export const enum InventoryStatusTypeEnum {
    PROCESS = 'process',
    FILLED = 'filled',
    CHECKED = 'checked',
    LISTED = 'listed',
    DONE = 'done',
    FAIL = 'fail',
}
